const long_names = [
    "Januari", "Februari", "Mars", "April", "Maj", "Juni",
    "Juli", "Augusti", "September", "Oktober", "November", "December"];

const small_names = [
    "Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"
];

const dayNames = [
    'Söndag', 'Måndag', 'Tisdag',
    'Onsdag', 'Torsdag', 'Fredag', 'Lördag'
];

const dayNamesShort = [
    'Sön', 'Mån', 'Tis',
    'Ons', 'Tors', 'Fre', 'Lör'
];

export function getMonthNameSmall(date) {
    return getMonthName(date, true);
}

export function getMonthName(date, small = false) {
    date = parseDate(date);

    const names = small ? small_names : long_names;
    const month = date.getMonth();
    return names[month];
};

export function getDayName(date) {
    date = parseDate(date);

    return dayNames[date.getDay()];
};

export function getDayNameShort(date) {
    date = parseDate(date);
    return dayNamesShort[date.getDay()];
}

export function getDate(date) {
    date = parseDate(date);

    var val = date.getDate();
    if( val > 9 )
        return val;
    return val;
};

export function getYear(date) {
    date = parseDate(date);

    return date.getFullYear();
};

export function getYMD(date) {
    date = parseDate(date);

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let min = date.getMinutes();

    if( month < 10 ) month = '0' + month;
    if( day < 10 ) day = '0' + day;
    if( hours < 10 ) hours = '0' + hours;
    if( min < 10 ) min = '0' + min;

    return year + '-' + month + '-' + day;
};

export function getYMDHI(date) {
    date = parseDate(date);

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let min = date.getMinutes();

    if( month < 10 ) month = '0' + month;
    if( day < 10 ) day = '0' + day;
    if( hours < 10 ) hours = '0' + hours;
    if( min < 10 ) min = '0' + min;

    return year + '-' + month + '-' + day + ' ' + hours + ':' + min;
};

export function getTime(date) {
    date = parseDate(date);

    let hours = date.getHours();
    let min = date.getMinutes();
    if( min < 10 ) min = '0' + min
    if( hours < 10 ) hours = '0' + hours
    return hours + ':' + min
}

export function parseDate(date) {
    if(typeof(date) === 'string') {
        return new Date(date);
    }

    if(typeof(date) === 'number') {
        return new Date(date * 1000);
    }

    return date;
}
